import { Mapper } from "../../../../base/utils/mapper";
import { TypeMaterialGlassesModel } from "../../../../domain/models/consult/type-material-glasses.model";
import { TypeMaterialGlassesEntity } from "../entities/type-material-glasses.entity";

export class TypeMaterialGlassesImplementationRepositoryMapper extends Mapper<TypeMaterialGlassesEntity, TypeMaterialGlassesModel> {
    mapFrom(param: TypeMaterialGlassesEntity): TypeMaterialGlassesModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeMaterialGlassesModel): TypeMaterialGlassesEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}